export const HANDLING_CODES = {
  NOTHING_TO_DO: 1,
  FATAL: -1,
};

export const CUSTOM_ERRORS = {
  EMPTY_CONTACT_MEDIA: { status: 'emptyContactMedia' },
  ALREADY_CLIENT: { status: 'alreadyClient' },
};

export const ERROR_PAGES = {
  DEFAULT: 'default',
  CHECKOUT: 'checkout',
  INCOMPATIBLE_ADDITIONAL_FIBER_ERROR_PAGE:
    'incompatibleAdditionalFiberErrorPage',
  ALREADY_PURCHASE_ADDITIONAL_FIBER_ERROR_PAGE:
    'alreadyPurchaseAdditionalFiberErrorPage',
  ALREADY_PURCHASE_BAF_ERROR_PAGE: 'alreadyPurchaseBafErrorPage',
  EMPTY_CONTACT_MEDIA_ERROR_PAGE: 'emptyContactMediaErrorPage',
  WRONG_ZONE_MIMOVISTAR_NO_CLIENTE: 'wrongZoneMiMovistarNoCliente',
  INCOMPATIBLE_LMA_ERROR_PAGE: 'incompatibleLmaErrorPage',
  INCOMPATIBLE_LMC_BUNDLE_ERROR_PAGE: 'incompatibleLmcBundleErrorPage',
  ALREADY_PURCHASE_TV_ERROR_PAGE: 'alreadyPurchaseTvErrorPage',
  ALREADY_PURCHASE_PROMO_TV_ERROR_PAGE: 'alreadyPurchasePromoTvErrorPage',
  PROMO_EXPIRED_TV_ERROR_PAGE: 'promoExpiredTvErrorPage',
  ALREADY_PURCHASE_PROMO_FA_ERROR_PAGE: 'alreadyPurchasePromoFaErrorPage',
  PROMO_EXPIRED_FA_ERROR_PAGE: 'promoExpiredFaErrorPage',
  DEFAULT_TV: 'defaultTv',
  ALREADY_CLIENT: 'alreadyClient',
};

export const WEB_SERVICES = {
  INIT_PURCHASE_BAF: 'initPurchaseBaf',
  INIT_PURCHASE_MOBILE_LINE: 'initPurchaseMobileLine',
  INIT_PURCHASE_ADDITIONAL_FIBER: 'initPurchaseAdditionalFiber',
  INIT_PURCHASE_MIMOVISTAR_NO_CLIENTE: 'initPurchaseMimovistarNoCliente',
  INIT_PURCHASE_TV: 'initPurchaseTv',
  SET_INFO_BAF: 'setInfoBaf',
  SET_INFO_MOBILE_LINE: 'setInfoMobileLine',
  SET_INFO_ADDITIONAL_FIBER: 'setInfoAdditionalFiber',
  SET_INFO_MIMOVISTAR_NO_CLIENTE: 'setInfoMiMovistarNoCliente',
  SET_INFO_MAPS: 'setInfoMaps',
  CHECKOUT: 'checkout',
  CHECKOUT_TV: 'checkoutTv',
  SEND_SMS_OTP: 'sendSmsOtp',
  VALIDATE_SMS_OTP: 'validateSmsOtp',
  SEND_SMS_OTP_TV: 'sendSmsOtpTv',
  VALIDATE_SMS_OTP_TV: 'validateSmsOtpTv',
  PROCESS_ORDER: 'processOrder',
  PROCESS_ORDER_TV: 'processOrderTv',
  RETARGETING: 'retargeting',
  GET_EXTRA_APPOINTMENT_OPTIONS: 'getExtraAppointmentOptions',
};
